export default {"src":"/_next/static/media/matching-mini.6f71d386.svg","height":24,"width":24};